import React from "react"
import { SEGMENTS } from "../../utils/constants"
import { isModuleBySlug } from "../../utils/storage"
import { get, map, pick } from "lodash"
import {
  Button,
  Steps,
  Input,
  Tooltip,
  Radio,
  Select,
  Space,
  Popover,
  Table,
} from "antd"

import Loader from "components/Loader"

import questionIcon from "../../images/question.svg"
import "./index.less"

const { Option } = Select

const MeasureEdit = (props) => {
  const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
  let selectedSegmentsWithSurveys = []

  props.selectedSegments.forEach((segmentId) => {
    const segment = props.segments.find(
      (segment) => segment.id_segment === segmentId
    )
    selectedSegmentsWithSurveys.push(segment)
  })

  const contentSegment = (
    <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
      Solo será posible seleccionar segmentos que cuenten con al menos un
      cuestionario asociado para el indicador a medir seleccionado.
    </div>
  )

  const saveSurveyIdForSegment = (surveyId, segmentId) => {
    // const { segmentsAndSurveys } = this.state
    let push = true
    const newSegmentsAndSurveys = props.segmentsAndSurveys.map((item) => {
      if (item.id_segment === segmentId) {
        push = false
        return {
          id_segment: segmentId,
          id_survey: surveyId,
        }
      }
      return item
    })
    if (push) {
      newSegmentsAndSurveys.push({
        id_segment: segmentId,
        id_survey: surveyId,
      })
    }
    props.setStateFrom("segmentsAndSurveys", newSegmentsAndSurveys)
    // this.setState({ segmentsAndSurveys: newSegmentsAndSurveys })
  }

  const removeSegmentFromSurvey = (segmentId) => {
    const newSegmentsAndSurveys = props.segmentsAndSurveys.filter((item) => {
      return item.id_segment !== segmentId
    })
    props.setStateFrom("segmentsAndSurveys", newSegmentsAndSurveys)
  }

  return (
    <div className="measurement-new">
      <div className="measurement-new-header">
        <div className="measurement-new-header-title">Configurar medición</div>
        <span style={{ marginBottom: "4px", marginTop: "12px" }}>
          <strong style={{ fontWeight: "600", fontSize: "14px" }}>
            Nombre de la medición<span className="red">*</span>:
          </strong>
        </span>
        <Input
          style={{ width: "25%", marginBottom: "16px" }}
          maxLength={200}
          placeholder="Ejemplo: Clima Laboral 2018"
          value={props.nameMeasure}
          onChange={
            (e) =>
              props.setStateFrom(
                "nameMeasure",
                e.target.value
              ) /* this.setState({ name: e.target.value }) */
          }
        />
        <span style={{ marginBottom: "4px" }}>
          <strong style={{ fontWeight: "600" }}>Indicador a medir<span className="red">*</span>:</strong>
        </span>
        <Select
          disabled
          style={{ width: "25%", marginBottom: "16px" }}
          // disabled={this.state.clickedModel}
          placeholder="Seleccionar tipo"
          value={props.surveyType}
          onChange={(e) => {
            // this.setState({ surveyType: e })
            props.setStateFrom("surveyType", e)
            props.setStateFrom("scopeType", 1)
            props.setStateFrom("selectedSegments", [])
            props.setStateFrom("selectedSurvey", undefined)
            props.setStateFrom("segmentsAndSurveys", [])
            props.getOrganizationSurveysWatcher(e)
            props.getSegmentsWatcher(e)
          }}>
          {map(props.surveyTypes, (item, index) => {
            if (item) {
              return (
                <Option key={index} value={item.id_survey_type}>
                  {item.name}
                </Option>
              )
            }
          })}
        </Select>
        {isSegmentsEnabled && (
          <>
            <span style={{ marginBottom: "4px" }}>
              <strong style={{ fontWeight: "600" }}>Alcance<span className="red">*</span>:</strong>
            </span>
            <Radio.Group
              style={{ marginBottom: "12px" }}
              value={props.scopeType}
              onChange={
                (e) => {
                  props.setStateFrom("scopeType", e.target.value)
                  props.setStateFrom("selectedSegments", [])
                  props.setStateFrom("selectedSurvey", undefined)
                  props.setStateFrom("segmentsAndSurveys", [])
                }
                // this.setState({ scopeType: e.target.value })
              }>
              <Space direction="vertical">
                {map(props.scopeTypes, (item, index) => {
                  if (item) {
                    if (item.id_scope_type === 1) {
                      return (
                        <Radio
                          value={item.id_scope_type}
                          disabled={props.organizationSurveys.length === 0}>
                          {props.organizationSurveys.length === 0 ? (
                            <Popover
                              placement="top"
                              content='No cuentas con cuestionarios asignados a "Toda la organización" para el indicador.'>
                              {item.name}
                            </Popover>
                          ) : (
                            <>{item.name} </>
                          )}
                        </Radio>
                      )
                    }

                    if (item.id_scope_type === 2) {
                      return (
                        <Radio
                          value={item.id_scope_type}
                          disabled={props.segments.length === 0}>
                          {props.segments.length === 0 ? (
                            <Popover
                              placement="top"
                              content="No cuentas con cuestionarios asignados a segmentos específicos para el indicador.">
                              Segmentos
                            </Popover>
                          ) : (
                            <>Segmentos </>
                          )}
                          <Popover placement="top" content={contentSegment}>
                            <img src={questionIcon} style={{ marginLeft: 8 }} />
                          </Popover>
                        </Radio>
                      )
                    }
                    return <Radio value={item.id_scope_type}>{item.name}</Radio>
                  }
                })}
              </Space>
            </Radio.Group>
            {props.scopeType === 2 && (
              <Select
                optionFilterProp="name"
                mode="multiple"
                allowClear
                placeholder="Seleccionar segmentos"
                maxTagCount={3}
                maxTagTextLength={14}
                style={{ marginTop: "12px" }}
                loading={props.isLoadingSegments}
                value={props.selectedSegments}
                style={{
                  width: "25%",
                  marginBottom: "12px",
                }}
                onClear={() => {
                  props.setStateFrom("segmentsAndSurveys", [])
                  props.setStateFrom("selectedSegments", [])
                }}
                onDeselect={(e) => {
                  removeSegmentFromSurvey(e)
                }}
                onChange={(e) => {
                  // this.setState({ selectedSegments: e })
                  props.setStateFrom("selectedSegments", e)
                  e.forEach((item) => {
                    const segment = props.segments.find(
                      (segment) => segment.id_segment === item
                    )
                    if (segment.surveys.length === 1) {
                      saveSurveyIdForSegment(
                        segment.surveys[0].id_survey,
                        segment.id_segment
                      )
                    }
                  })
                }}>
                {props.segments.map((segment, index) => {
                  return (
                    <Option
                      key={index}
                      value={segment.id_segment}
                      name={segment.name}>
                      {segment.name}
                    </Option>
                  )
                })}
              </Select>
            )}
          </>
        )}
        {props.scopeType === 1 && (
          <>
            <span
              style={{
                marginBottom: "4px",
              }}>
              <strong style={{ fontWeight: "600" }}>Cuestionario<span className="red">*</span>:</strong>
            </span>
            <Select
              optionFilterProp="name"
              style={{ width: "25%", marginBottom: "16px" }}
              // disabled={this.state.clickedModel}
              loading={props.isLoadingOrganizationSurveys}
              placeholder="Seleccionar cuestionario"
              value={props.selectedSurvey}
              onChange={(e) =>
                // this.setState({ selectedSurvey: e })
                props.setStateFrom("selectedSurvey", e)
              }>
              {map(props.organizationSurveys, (item, index) => {
                if (item) {
                  return (
                    <Option key={index} value={item.id_survey} name={item.name}>
                      {item.name}
                    </Option>
                  )
                }
              })}
            </Select>
          </>
        )}
        {props.scopeType === 2 && (
          <>
            <span
              style={{
                marginBottom: "4px",
              }}>
              <strong style={{ fontWeight: "600" }}>Cuestionario(s)*:</strong>
            </span>
            <span
              style={{
                marginBottom: "12px",
                fontSize: "13px",
                color: "#4F4F4F",
              }}>
              Selecciona el cuestionario a utilizar para cada uno de los
              segmentos elegidos.
            </span>
            {props.selectedSegments.length > 0 && (
              <Table
                bordered
                style={{ width: "50%" }}
                pagination={false}
                size="small"
                columns={[
                  {
                    title: "Segmento",
                    width: "50%",
                    dataIndex: "name",
                    key: "name",
                    render: (text) => (
                      <span style={{ color: "#555151" }}>{text}</span>
                    ),
                  },
                  {
                    title: "Cuestionario",
                    dataIndex: "survey",
                    width: "50%",
                    key: "survey",
                    render: (text, record) => {
                      if (record) {
                        if (record.surveys.length === 1) {
                          return (
                            <Select
                              value={record.surveys[0].id_survey}
                              onChange={(e) => {
                                saveSurveyIdForSegment(e, record.id_segment)
                              }}
                              placeholder="Seleccionar cuestionario"
                              style={{ width: "100%" }}>
                              {map(record.surveys, (item, index) => {
                                return (
                                  <Option key={index} value={item.id_survey}>
                                    {item.name}
                                  </Option>
                                )
                              })}
                            </Select>
                          )
                        }

                        return (
                          <Select
                            value={
                              props.segmentsAndSurveys.find(
                                (element) =>
                                  element.id_segment === record.id_segment
                              )
                                ? props.segmentsAndSurveys.find(
                                    (element) =>
                                      element.id_segment === record.id_segment
                                  ).id_survey
                                : undefined
                            }
                            placeholder="Seleccionar cuestionario"
                            onChange={(e) => {
                              saveSurveyIdForSegment(e, record.id_segment)
                            }}
                            style={{ width: "100%" }}>
                            {map(record.surveys, (item, index) => {
                              return (
                                <Option key={index} value={item.id_survey}>
                                  {item.name}
                                </Option>
                              )
                            })}
                          </Select>
                        )
                      }
                    },
                  },
                ]}
                dataSource={selectedSegmentsWithSurveys}
              />
            )}
          </>
        )}
        <span style={{ marginBottom: "4px", marginTop: "12px" }}>
          <strong style={{ fontWeight: "600", fontSize: "14px" }}>
            Tipo<span className="red">*</span>:
          </strong>
        </span>
        <Radio
          checked={props.measureType === 1}
          value={1}
          onChange={(e) => {
            props.setStateFrom("measureType", e.target.value)
            // this.setState({ measureType: e.target.value })
          }}>
          Medición
        </Radio>
        <span className="measurement-new-type-description">
          La medición es representativa de toda la población, por lo que sus
          resultados serán considerados para el{" "}
          <strong>análisis de la evolución histórica</strong> del indicador a
          medir.
        </span>
        <Radio
          checked={props.measureType === 2}
          value={2}
          onChange={(e) => {
            props.setStateFrom("measureType", e.target.value)
            // this.setState({ measureType: e.target.value })
          }}>
          Pulso
        </Radio>
        <span className="measurement-new-type-description">
          La medición <strong>no</strong> es representativa de toda la
          población, por lo que sus resultados{" "}
          <strong className="measurement-new-type-description-underline">
            no
          </strong>{" "}
          serán considerados para el{" "}
          <strong>análisis de la evolución histórica</strong> del indicador a
          medir, ni contarán con evolución histórica versus mediciones
          anteriores.
        </span>
      </div>
    </div>
  )
}

export default MeasureEdit
